import appConstants from '../../../../../../../../../constants';
import computeClassName from '../../../../../../../../../utils/computeClassName';
//import { useUserContext } from '../../../../../../../ContextProvider/User';
import { useScreenContext } from '../../../../../../../ContextProvider/Screen';
//import { useNotificationsContext } from '../../../../../../../ContextProvider/Notifications';
import { usePartnerSearchContext } from '../../../../../../../ContextProvider/Partner/Search';
import CCBadgeLightRemovable from '../../../../../../../../libs/CiscoCore/Badge/Light/Removable';
//import CCFormInputButtonSecondary from '../../../../../../../../libs/CiscoCore/Form/Input/Button/Secondary';

const constants = Object.freeze({
  CLASSNAME_BASE: 'list-none flex overflow-x-auto sm:overflow-hidden sm:flex-wrap items-center justify-start -mx-1 xs:-mx-2',
});

function getComputedBadgeOrButtonSize(useMediumSize, useLargeSize) {
  let badgeSize = 'small';
  if (useMediumSize) { badgeSize = 'medium'; }
  if (useLargeSize) { badgeSize = 'large'; }
  return badgeSize
}

function getComputedRemoveFn(
  selectedCriteriaSelectionForm,
  searchCriterion,
  searchCriterionTypeKey,
  searchCriterionSubTypeKey,
  filterTypeSubTypeUnselectFnMapping,
  suggestionTypeSubTypeUnselectFnMapping,
) {
  switch (selectedCriteriaSelectionForm) {
    case appConstants.SEARCH_FORM_SEARCH_BY_COMBINED_CRITERIA:
      return () => { suggestionTypeSubTypeUnselectFnMapping[`${searchCriterion[searchCriterionTypeKey]}-${searchCriterion[searchCriterionSubTypeKey]}`](searchCriterion); }
    case appConstants.SEARCH_FORM_SEARCH_BY_LOCATION:
    case appConstants.SEARCH_FORM_FILTER_BY_NEED:
    default:
      return () => { filterTypeSubTypeUnselectFnMapping[`${searchCriterion[searchCriterionTypeKey]}-${searchCriterion[searchCriterionSubTypeKey]}`](searchCriterion); }
  }
}

export default function CriterionList({className}) {
  const computedClassName = computeClassName(className, constants.CLASSNAME_BASE);
  const { isScreenXSAndUp, isScreenMDAndUp } = useScreenContext();
  const computedBadgeSize = getComputedBadgeOrButtonSize(isScreenXSAndUp, isScreenMDAndUp);
  //const computedButtonSize = getComputedBadgeOrButtonSize(isScreenMDAndUp, false);
  const {
    searchCriteria,
    getCurrentSelectedForm,
    filterTypeSubTypeUnselectFnMapping,
    suggestionTypeSubTypeUnselectFnMapping
  } = usePartnerSearchContext();

  //const { notifyMustLogInFn } = useNotificationsContext();
  //const { user } = useUserContext();
  //const computedSaveSearchButtonClickFn = user.isLoggedIn()? null:notifyMustLogInFn;
  const selectedCriteriaSelectionForm = getCurrentSelectedForm();
  //const computedMustSavedSearchBeShown = !!searchCriteria.length && selectedCriteriaSelectionForm === appConstants.SEARCH_FORM_SEARCH_BY_COMBINED_CRITERIA;
  return (
    <ul className={computedClassName}>
      {
        searchCriteria.map((searchCriterion, index) => {
          const computedRemoveFn =
            getComputedRemoveFn(
              selectedCriteriaSelectionForm,
              searchCriterion,
              appConstants.KEY_TYPE,
              appConstants.KEY_SUBTYPE,
              filterTypeSubTypeUnselectFnMapping,
              suggestionTypeSubTypeUnselectFnMapping
            );
          return (
            <li key={index} className="sm:my-2 mx-1 sm:mx-2">
              <CCBadgeLightRemovable size={computedBadgeSize}
                                     removeControlFn={computedRemoveFn}
                                     removeControlFnArgs={searchCriterion}
                                     className="whitespace-nowrap">{searchCriterion[appConstants.KEY_NAME]}</CCBadgeLightRemovable>
            </li>
          );
        })
      }
    </ul>
  );
}

//       {
//         computedMustSavedSearchBeShown &&
//         <li className="my-1 ml-1 xs:ml-2">
//           <CCFormInputButtonSecondary size={computedButtonSize} value="Save Search" clickFn={computedSaveSearchButtonClickFn}/>
//         </li>
//       }
